<template>
  <div class="va-data-table">
    <va-inner-loading :loading="loading">

      <div class="table-title" v-if="title">
        {{ title }}
      </div>

      <vuetable ref="vuetable" :api-mode="false" :fields="fields" :data="apiMode ? data : undefined"
        :data-manager="apiMode ? undefined : customDataManager ? customDataManager : dataManager" :pagination-path="apiMode ? '' : 'pagination'"
        :no-data-template="noDataLabel" :css="styles" :rowClass="rowClass" @vuetable:row-clicked="rowClicked" :table-height="tableHeight">
        <!-- https://stackoverflow.com/questions/50891858/vue-how-to-pass-down-slots-inside-wrapper-component   -->
        <!-- <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
          <slot :name="slot" v-bind="scope" />
        </template> -->

        <template slot="estoque" class="action-slot" slot-scope="props">
          <i class="fa fa-arrow-up" v-bind:title="props.rowData.arrowUp.title" v-if="props.rowData.arrowUp" v-bind:class="props.rowData.arrowUp.class"></i>
          <i class="fa fa-arrow-down" v-bind:title="props.rowData.arrowDown.title" v-if="props.rowData.arrowDown" v-bind:class="props.rowData.arrowDown.class"></i>
          <i class="fa fa-arrow-right" v-bind:title="props.rowData.neutral.title" v-if="props.rowData.neutral" v-bind:class="props.rowData.neutral.class"></i>
        </template>

        <template  slot="ativacao" slot-scope="props">
          <va-button flat small color="danger" @click="ativar(props)" class="ma-0" v-if="!props.rowData.ativo">
            <i class="fa fa-undo"></i>
          </va-button>

          <va-button flat small color="danger" @click="desativar(props)" class="ma-0"  v-if="props.rowData.ativo">
            <i class="fa fa-ban"></i>
          </va-button>
        </template>

        <template  slot="edicao" slot-scope="props">
          <va-button flat small color="gray" @click="editar(props)" class="ma-0" :disabled="props.rowData.ativo == false">
            <i class="fa fa-pencil"></i>
          </va-button>
        </template>

        <template  slot="delecao" slot-scope="props">
          <va-button flat small color="danger" @click="deletar(props)" class="ma-0">
            <i class="fa fa-trash-o"></i>
          </va-button>
        </template>

        <tr slot="tableFooter" slot-scope="props" class="table-footer" v-if="footerObj">
          <td v-for="col in props.fields" :key="col.$index">{{footerObj[col.name]}}</td>
        </tr>
      </vuetable>

      <div v-if="!noPagination && paginationTotal > 1" class="va-data-table__pagination">
        <va-pagination v-model="currentPage" :pages="paginationTotal" :visible-pages="visiblePages"
          :boundary-links="paginationTotal > visiblePages" @input="inputPage" />
      </div>
    </va-inner-loading>
  </div>
</template>

<script>

import VaDataTable from 'vuestic-ui/src/components/vuestic-components/va-data-table/VaDataTable.vue'
import SPMapaNomes from '@/utils/SPMapaNomes'

export default {
  name: 'sp360-data-table',
  mixins: [VaDataTable],
  props: {
    customDataManager: {
      type: Function,
      default: null,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    footerObj: {
      type: Object,
      default: null,
    },
    tableHeight:{
      type: String,
      default:''
    },
  },

  methods: {
    buildPagination (l, perPage) {
      return this.$refs.vuetable.makePagination(l, perPage)
    },
    sortAsc (items, field) {
      return _.orderBy(items, [field], ['asc'])
    },
    sortDesc (items, field) {
      return _.orderBy(items, [field], ['desc'])
    },
    editar (props) {
      this.$emit('editarRow', props)
    },
    ativar (props) {
      this.$emit('ativarRow', props)
    },
    desativar (props) {
      this.$emit('desativarRow', props)
    },
    deletar (props) {
      this.$emit('deletarRow', props)
    },
    header (props) {
      !!this.title
    },

    buildTableClass () {
      let name = 'va-data-table__vuetable va-table '

      if (this.striped) {
        name += ' va-table--striped'
      }
      if (this.clickable) {
        name += ' va-table--clickable'
      }

      if (this.hoverable) {
        name += ' va-table--hoverable'
      }

      return name
    },

    filterByString (array, string) {
      return array.filter((obj) => {
        return Object.keys(obj).reduce((acc, curr) => {
          if (typeof obj[curr] === 'string') {
            return acc || obj[curr].toLowerCase().includes(string.trim().toLowerCase())
          } else if (typeof obj[curr] === 'number') {
            let a = _.find(SPMapaNomes, (e) => { return (e.id === obj[curr] && e.nome === string) && e.nome })
            if (a) return acc || a
            return acc || obj[curr] <= parseInt(string)
          } else {
            return acc
          }
        }, false)
      })
    },

    filterByNumber (array, number) {
      let qtd = number.split('').length
      return array.filter((obj) => {
        return Object.keys(obj).reduce((acc, curr) => {
          if (typeof obj[curr] === 'number') {
            let aux = 0
            for (let i = 0; i < qtd; i++) {
              if (parseFloat(String(obj[curr]).charAt(i)) == parseInt(number.charAt(i))) aux++
            }
            if (aux == qtd) {
              return obj[curr]
            }
            return acc
          }
        }, false)
      })
    },

    filterByRange (array, [inicial, final], atributo) {
      return array.filter((obj) => {
        return Object.keys(obj).reduce((acc, curr) => {
          return acc || (parseFloat(obj.perc_estoque) <= final && parseFloat(obj[atributo]) >= inicial)
        }, false)
      })
    },

    _menorOuIgual (a, b) { return a <= b },
    _maiorOuIgual (a, b) { return a >= b },
    _estritamenteIgual (a, b) { return a === b },
    _estritamenteMaior (a, b) { return a === b },
    _estritamenteMenor (a, b) { return a === b },
  },
}
</script>

<style lang="scss" >
  @import "~vuestic-ui/src/components/vuestic-sass/resources/resources";
  $font-cabecalho : 1.35rem;

  .va-data-table {
    &__vuetable {
      height: 100%;
    }
  }

  .red-arrow{
    color: $theme-red;
  }

  .green-arrow{
    color: $vue-green;
  }

  .table-title {
    font-weight: 200;
    font-size: $font-cabecalho !important;
    letter-spacing: $card-title-letter-spacing;
    text-transform: none;
    color: $vue-darkest-blue !important;
    font-family: Source Sans Pro Semibold, sans-serif;
    padding-bottom:2%;
  }

  .table-footer{
    border-top: 2px solid #000000;
    background-color: #ffffff;
    font-weight: bold;
  }

  .filter-input{
    margin-left: 50%;
  }
</style>
